/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import TargetDetail from './detailCard';
import { openModal } from '../../actions/modalActions';
import { hyphenate } from '../../utils/string';
import { dateRange } from '../../utils/dateHelpers';
import StoryList from '../PlanWall/storyList';
import PointSummation from '../Common/pointSummation';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import {
  checkResultsToBeTransfered,
  startTarget
} from '../../utils/targetHelpers';
import { allows } from '../../utils/authorization';

class TargetRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: props.fromWall };
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.targetInfo = this.targetInfo.bind(this);
  }

  // constrain width to prevent overflow
  componentDidMount() {
    const mainWrapDiv = document.querySelector('div[ref=mainWrap]');
    mainWrapDiv.classList.add('constrain_width');
  }

  openTarget = () => {
    const { target } = this.props;
    this.props.openModal(
      { name: 'TARGET_DETAIL', component: TargetDetail },
      { id: target.id }
    );
  };

  targetInfo(target) {
    let info = '';
    const timeLeft = moment
      .duration(moment(target.end_date).diff(moment().startOf('day')))
      .asDays();
    const day = timeLeft < 1 ? 'today' : 'tomorrow';
    info = `ends ${timeLeft > 1 ? `in ${timeLeft} days` : day}`;

    return info;
  }

  toggleVisibility() {
    this.setState(
      (prevState) => ({ visible: !prevState.visible }),
      this.saveComponentState
    );
  }

  panelHeading() {
    const { target, results } = this.props;
    const caret = this.state.visible
      ? 'glyphicon-triangle-bottom'
      : 'glyphicon-triangle-right';
    const isAllowedToUpdate = allows('update', target);

    return (
      <div className="panel-title row ">
        <div className="col-md-2 cadence_header_1A">
          <span
            className={`glyphicon ${caret} cadence_header_fragment cadence_header_1A`}
            onClick={this.toggleVisibility}
            aria-hidden="true"
          />
          {isAllowedToUpdate && (
            <ul className="dropdown-menu " aria-labelledby="dropdown">
              {target.status === WorkPackageStatuses.GETTING_READY && (
                <li>
                  <button
                    type="button"
                    className="btn btn-link single_action_menu_option"
                    onClick={() => startTarget(target)}
                  >
                    Start target
                  </button>
                </li>
              )}
              {target.status === WorkPackageStatuses.IN_PROGRESS && (
                <li className="cadence_header_fragment ">
                  <button
                    type="button"
                    className=" btn btn-link"
                    onClick={() => checkResultsToBeTransfered(target, results)}
                  >
                    End target
                  </button>
                </li>
              )}
            </ul>
          )}
        </div>
        <div className="col-md-8 cadence_header_fragment cadence_header_1C">
          <div className="col-md-5 truncate">
            <a onClick={this.openTarget}>
              {target.short_name ? target.short_name : `Target ${target.id}`}
            </a>
          </div>
          <div className="col-md-7 truncated-text cadence_header_fragment cadence_header_1D">
            <small>{dateRange(target)}</small>
          </div>
        </div>
        <div className="col-md-4 right cadence_header_fragment cadence_header_1F">
          <PointSummation stories={results} />
        </div>
      </div>
    );
  }

  render() {
    const { target, results, showCompleted, add, remove } = this.props;
    const targetCompleted =
      target.status === WorkPackageStatuses.ACCEPTED ||
      target.status === WorkPackageStatuses.LIVE;

    if (!showCompleted && targetCompleted) return null;

    const deletedClassName = target.deleted_at ? 'deleted' : '';

    return (
      <div
        className={`target-row panel ${
          target.status && hyphenate(target.status)
        } ${deletedClassName}`}
      >
        <div className="panel-heading">{this.panelHeading()}</div>
        <div className={`panel-body ${!this.state.visible && 'hide'}`}>
          <StoryList
            results={results}
            source={`card${target.id}`}
            level={3}
            parentId={target.id}
            add={(workPackageId, targetId) =>
              add(workPackageId, targetId, true)}
            delete={remove}
            expand
            mini
            targetRow
          />
        </div>
      </div>
    );
  }
}

TargetRow.propTypes = {
  target: PropTypes.object,
  preservedState: PropTypes.object,
  results: PropTypes.array,
  fromWall: PropTypes.bool,
  showCompleted: PropTypes.bool,
  collapsed: PropTypes.bool,
  add: PropTypes.func,
  remove: PropTypes.func,
  preserveComponentState: PropTypes.func,
  startTarget: PropTypes.func,
  checkResultsToBeTransfered: PropTypes.func
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(TargetRow);
